"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inversion = void 0;
const inversion = (higherAltitudeTemperature, lowerAltitudeTemperature) => {
    if (higherAltitudeTemperature === null || lowerAltitudeTemperature === null)
        return null;
    if (higherAltitudeTemperature === undefined || lowerAltitudeTemperature === undefined)
        return null;
    if (typeof higherAltitudeTemperature !== 'number' || typeof lowerAltitudeTemperature !== 'number')
        return null;
    return higherAltitudeTemperature - lowerAltitudeTemperature;
};
exports.inversion = inversion;
//# sourceMappingURL=inversion.js.map